import React, { useEffect, useState } from 'react';
import { useContracts } from '../../hooks/useContract';
import { useNotify } from '../../context/NotificationContext';
import { ButtonSpinner } from '../common/Loader';
import { parseError } from '../../utils/errors';
import { formatBps } from '../../utils/format';

export const FeeManagement = () => {
  const { viewsR, adminW } = useContracts();
  const notify = useNotify();

  const [fees, setFees] = useState(null);
  const [busy, setBusy] = useState(null);
  const [team, setTeam] = useState('');
  const [liq, setLiq]   = useState('');
  const [pool, setPool] = useState('');
  const [adminFee, setAdminFee] = useState('');
  const [levelFee, setLevelFee] = useState('');
  const [expenseFee, setExpenseFee] = useState('');
  const [reload, setReload] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!viewsR) return;
      try {
        const f = await viewsR.getFees();
        if (cancelled) return;
        setFees(f);
      } catch (e) {}
    };
    load();
    return () => { cancelled = true; };
  }, [viewsR, reload]);

  const runTx = async (label, fn) => {
    setBusy(label);
    try {
      const tx = await fn();
      notify.info(`${label}: submitted`);
      await tx.wait();
      notify.success(`${label}: success`);
      setReload((r) => r + 1);
    } catch (e) {
      notify.error(parseError(e));
    } finally {
      setBusy(null);
    }
  };

  return (
    <div>
      <div className="card mb-24">
        <div className="section-title">Current Fees</div>
        {fees && (
          <div className="kv-list">
            <div className="kv-row"><span className="kv-key">Team Wallet</span><span className="kv-val">{formatBps(fees.teamFee)}</span></div>
            <div className="kv-row"><span className="kv-key">Liquidity</span><span className="kv-val">{formatBps(fees.liquidityFee)}</span></div>
            <div className="kv-row"><span className="kv-key">Rank Pool Total</span><span className="kv-val">{formatBps(fees.rankPoolTotal)}</span></div>
            <div className="kv-row"><span className="kv-key">Admin Withdraw</span><span className="kv-val">{formatBps(fees.adminWithdraw)}</span></div>
            <div className="kv-row"><span className="kv-key">Level Withdraw</span><span className="kv-val">{formatBps(fees.levelWithdraw)}</span></div>
            <div className="kv-row"><span className="kv-key">Expense</span><span className="kv-val">{formatBps(fees.expense)}</span></div>
          </div>
        )}
      </div>

      <div className="card mb-24">
        <div className="section-title">Update Fee Splits (bps, must total 10000)</div>
        <div className="admin-form-grid">
          <div className="input-group">
            <label className="input-label">Team (bps)</label>
            <input className="input" type="number" placeholder="2000" value={team} onChange={(e) => setTeam(e.target.value)} />
          </div>
          <div className="input-group">
            <label className="input-label">Liquidity (bps)</label>
            <input className="input" type="number" placeholder="7600" value={liq} onChange={(e) => setLiq(e.target.value)} />
          </div>
          <div className="input-group">
            <label className="input-label">Rank Pool (bps)</label>
            <input className="input" type="number" placeholder="400" value={pool} onChange={(e) => setPool(e.target.value)} />
          </div>
        </div>
        <button
          className="btn btn-primary"
          disabled={busy === 'splits' || !team || !liq || !pool}
          onClick={() => runTx('splits', () => adminW.updateFeeSplits(team, liq, pool))}
        >
          {busy === 'splits' && <ButtonSpinner />}Update Splits
        </button>
      </div>

      <div className="card mb-24">
        <div className="section-title">Individual Fees</div>
        <div className="admin-form-grid">
          <div>
            <div className="input-group">
              <label className="input-label">Admin Withdraw Fee (bps, ≤5000)</label>
              <input className="input" type="number" value={adminFee} onChange={(e) => setAdminFee(e.target.value)} />
            </div>
            <button className="btn btn-secondary btn-sm" disabled={busy === 'admin' || !adminFee} onClick={() => runTx('admin', () => adminW.updateAdminWithdrawFee(adminFee))}>
              {busy === 'admin' && <ButtonSpinner />}Set
            </button>
          </div>
          <div>
            <div className="input-group">
              <label className="input-label">Level Withdraw Fee (bps, ≤5000)</label>
              <input className="input" type="number" value={levelFee} onChange={(e) => setLevelFee(e.target.value)} />
            </div>
            <button className="btn btn-secondary btn-sm" disabled={busy === 'level' || !levelFee} onClick={() => runTx('level', () => adminW.updateLevelWithdrawFee(levelFee))}>
              {busy === 'level' && <ButtonSpinner />}Set
            </button>
          </div>
          <div>
            <div className="input-group">
              <label className="input-label">Expense Fee (bps, ≤5000)</label>
              <input className="input" type="number" value={expenseFee} onChange={(e) => setExpenseFee(e.target.value)} />
            </div>
            <button className="btn btn-secondary btn-sm" disabled={busy === 'expense' || !expenseFee} onClick={() => runTx('expense', () => adminW.updateExpenseFee(expenseFee))}>
              {busy === 'expense' && <ButtonSpinner />}Set
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
